import React, {useEffect, useMemo, useState} from 'react';
import styles from "./MissionCreateOrEdit.module.scss";
import {PROD_API_URL} from "../../constants/constants";
import {useNavigate, useParams} from "react-router-dom";
import TextInput from "../../Components/TextInput/TextInput";
import TextAreaInput from "../../Components/TextAreaInput/TextAreaInput";
import {Checkbox, FormControlLabel, MenuItem, TextField} from "@mui/material";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import {PATH_IDO_ADMINISTRATION, PATH_MISSION_ADMINISTRATION, PATH_RAFFLE_ADMINISTRATION} from "../../App";
import {NEW_IDO_ID} from "../IdoAdministration/IdoAdministration";
import {
 handleImageUpload,
  hasValue
} from "../../helpers/helperFunctions";
import ImageSubmit from "../../Components/ImageSubmit/ImageSubmit";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import toast from "react-hot-toast";
import {errorToast, successToast} from "../../helpers/toastCSS";
import {useConnection} from "@solana/wallet-adapter-react";
import { Tooltip } from "react-tooltip";
import {NEW_MISSION_ID} from "../MissionsList/MissionsList";
import {NO_TOKENS_RESPONSE, starsDefaultToken} from "../RaffleEdit/raffleHelper";
import TokenModalSelect from "../../Components/TokenModalSelect/TokenModalSelect";
import {DataGrid} from "@mui/x-data-grid";
import {TASK_ACTIONS_LIST, TASK_ITEM_LIST} from "./missionHelper";
import { ReactComponent as TrashIcon } from "../../images/svg/trashIcon.svg";
import moment from "moment";
import TabSelector from "../../Components/TabSelector/TabSelector";
import TaskAdministrationList from "./TaskAdministrationList";
import MissionParticipantsList from "./MissionParticipantsList";

const TAB_GENERAL = 'General';
const TAB_TASKS = 'Tasks';
const TAB_PARTICIPANTS = 'Participants';

const tabOptions = [
  {key: TAB_GENERAL, label: 'General'},
  {key: TAB_TASKS, label: 'Tasks'},
  {key: TAB_PARTICIPANTS, label: 'Participants'},
];


const MissionCreateOrEdit = (props) => {
  const {
    provider
  } = props;
  
  const { id } = useParams();
  
  const { connection } = useConnection();
  const navigate = useNavigate();

  const [selectedMission, setSelectedMission] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [tokenList, setTokenList] = useState([]);
  const [currentTab, setCurrentTab] = useState(TAB_GENERAL);

  const [name, setName] = useState('');
  const [poolName, setPoolName] = useState('');
  const [description, setDescription] = useState('');
  const [missionType, setMissionType] = useState('');
  const [isPermanent, setIsPermanent] = useState(false);
  const [production, setProduction] = useState(false);
  const [prizes, setPrizes] = useState('');
  const [bannerImage, setBannerImage] = useState();
  const [imagePreview, setImagePreview] = useState();
  const [missionStartTime, setMissionStartTime] = useState();
  const [missionEndTime, setMissionEndTime] = useState();

  const [usePrizeToken, setUsePrizeToken] = useState(false);
  const [prizeToken, setPrizeToken] = useState(starsDefaultToken);
  const [tokenRewardAmount, setTokenRewardAmount] = useState('');
  const [rewardXPMultiplier, setRewardXPMultiplier] = useState('');
  const [rewardXPMultiplierDuration, setRewardXPMultiplierDuration] = useState('');
  const [xpReward, setXpReward] = useState('');
  const [taskList, setTaskList] = useState([]);


  const setIDODefaultData = (missionData) => {
    if (id === NEW_MISSION_ID) {
      return;
    }
    console.log(missionData)
    setSelectedMission(missionData);

    setName(missionData.name);
    setPoolName(missionData.poolName);
    setDescription(missionData.description);
    setMissionType(missionData.missionType);
    setIsPermanent(missionData.isPermanent);
    setProduction(missionData.production);
    setPrizes(missionData.prizes);
    setBannerImage(missionData.bannerImage);
    setImagePreview(missionData.bannerImage);
    setMissionStartTime(moment.unix(missionData.missionStartTime).utc());
    setMissionEndTime(moment.unix(missionData.missionEndTime).utc());

    if (missionData.prizeToken) {
      setPrizeToken(missionData.prizeToken);
    }

    setTokenRewardAmount(missionData.tokenRewardAmount);
    setXpReward(missionData.xpReward);

    if (missionData.tasks) {
      setTaskList(missionData.tasks);
    }
  }

  useEffect( ()=> {
      const fetchMissionData = async () => {
        if (id === NEW_MISSION_ID) {
          return;
        }
        fetch(PROD_API_URL+"/mission/" + id + '?allData=true', {
          "method": "GET",
          "headers": {"content-type": "application/json", "accept": "*"},
        }).then(res=>res.json())
          .then((result)=> {
            if (result) {
              setIDODefaultData(result.data)
            }
          });
    }
    
    if (!selectedMission) {
      fetchMissionData();
    }

  }, [selectedMission]);


  const hasAllMandatoryValues = useMemo(() => {
    let tooltip = '';

    if (!hasValue(name)) tooltip += 'Mission Name';

    if (!hasValue(missionStartTime) && !isPermanent) tooltip += ', Contribution StartTime';

    if (!hasValue(missionEndTime) && !isPermanent) tooltip += ', Contribution EndTime';

    return { disabled: tooltip !== '', tooltip }
  }, [name, missionStartTime, missionEndTime, poolName, isPermanent]);


  const saveChanges = async () => {
    try {

      const missionNameJoined = name.split(' ').join('_');
      const imageUrl = hasValue(bannerImage) && bannerImage !== selectedMission?.bannerImage ? await handleImageUpload(bannerImage, 'missions/banners', missionNameJoined) : selectedMission?.bannerImage;

      let body= {
        name,
        poolName,
        description,
        missionType,
        isPermanent,
        production,
        prizes,
        prizeToken,
        tokenRewardAmount,
        xpReward,
        usePrizeToken,
        rewardXPMultiplier,
        rewardXPMultiplierDuration,
        tasks: taskList,
        bannerImage: imageUrl,
        missionStartTime: moment(missionStartTime).utc().unix(),
        missionEndTime: moment(missionEndTime).utc().unix(),
      };

      if (hasValue(id) && id !== NEW_MISSION_ID) {
        body.id = selectedMission.id;
      }

      await fetch(PROD_API_URL + "/mission/createOrEdit", {
        "method": "POST",
        "headers": {"content-type": "application/json", "accept": "*"},
        "body": JSON.stringify(body)
      }).then(r => {
        if (r.ok && r.status === 200) {
          if (id === NEW_MISSION_ID) {
            toast('Mission Successfully Created!', successToast)
            navigate(PATH_MISSION_ADMINISTRATION);
          } else {
            toast('Mission Successfully updated!', successToast)
          }
        } else {
          toast('ERROR Saving Mission', errorToast)
        }
      })
    } catch (e) {
      toast('Something went wrong', errorToast);
      console.error(e);
    }

  }

  const deleteMission = async () => {
    try {
      await fetch(PROD_API_URL + "/mission/removeMission", {
        "method": "POST",
        "headers": {"content-type": "application/json", "accept": "*"},
        "body": JSON.stringify({ id: selectedMission.id})
      }).then(r => {
        if (r.ok && r.status === 200) {
          toast('Mission Successfully Removed!', successToast)
          navigate(PATH_MISSION_ADMINISTRATION);
        } else {
          toast('ERROR removing Mission', errorToast)
        }
      })
    } catch (e) {
      console.error(e);
    } finally {
      setOpenDeleteModal(false);
    }
  }

  const fetchToken = async (value) => {
    return await fetch(`${PROD_API_URL}/token/${value}`)
        .then(r => r.json())
        .then(response => {
          const result = response.data.map(token => {
            return {
              name: token.name,
              key: token.symbol,
              icon: token.icon,
              value:  token.mint,
              decimals: token.decimals,
            };
          })
          setTokenList(prev => {
            return (
                { searchedTokens: response.data.length !== 0 ? result : []}
            )
          })
          if (response.data.length === 0) return NO_TOKENS_RESPONSE;
        })
  }



  return (
    <main id="home" key="home" className={styles.mainMissionContainer}>
      <Tooltip id={"RaffleTooltip"} effect="solid" place="top" />
{/*      <DraftEditor
        open={openEditorModal}
        setClose={() => setOpenEditorModal(false)}
        setFinishedHtml={setHTMLDescription}
        valueHTML={HTMLDescription} />*/}
      {(selectedMission || id === NEW_MISSION_ID) && <div className={styles.missionAdminContainer}>
        <div className={styles.missionHeader}>
          <h4>{currentTab}</h4>
          <TabSelector
              options={tabOptions}
              setValue={setCurrentTab}
              tabContainerClassName={styles.tabSelector}
              value={currentTab} />
        </div>
        {currentTab === TAB_GENERAL && <div className={styles.missionContent}>
          <div className={styles.editRow}>
            <TextInput value={name} label="Name*" setValue={setName}/>
            <div className={styles.checkboxContainer}>
              <FormControlLabel
                  control={<Checkbox checked={production}
                                     onChange={event => setProduction(event.target.checked)}/>}
                  label="Show in production"
                  labelPlacement="top"
              />
            </div>
            <div className={styles.imageInputContainer}>
              <ImageSubmit base64Value={imagePreview} setBase64={setImagePreview} setFileInfo={setBannerImage} useBase64
                           text="Banner Image"/>
            </div>
          </div>

          <div className={styles.textAreaInputRow}>
            <div style={{flex: '1'}}>
              <TextAreaInput
                  value={description}
                  setValue={setDescription}
                  rows={4} l
                  label="Short Header Description"/>
            </div>
          </div>
          <div className={styles.editRow}>
            <TextInput value={xpReward} label="XP Reward" setValue={setXpReward}/>
            <TextInput value={rewardXPMultiplier} label="XP Multiplier Reward" setValue={setRewardXPMultiplier}/>
            <TextInput value={rewardXPMultiplierDuration} label="XP Multiplier Duration in days" setValue={setRewardXPMultiplierDuration}/>
          </div>
          <div className={styles.editRow}>
            <div className={styles.checkboxContainer}>
              <FormControlLabel
                  control={<Checkbox checked={usePrizeToken}
                                     onChange={event => setUsePrizeToken(event.target.checked)}/>}
                  label="Use a SPL Token For Reward"
                  labelPlacement="top"
              />
            </div>
            <div className={styles.tokenModalContainer}>
              <span className={styles.raffleTokenText}>Reward Token*</span>

              <TokenModalSelect
                  setValue={setPrizeToken}
                  value={prizeToken}
                  fetchToken={fetchToken}
                  options={tokenList}/>
            </div>
            <TextInput value={tokenRewardAmount} label="Token Reward Amount" setValue={setTokenRewardAmount} disabled={!usePrizeToken} />
          </div>
          <div className={styles.editRow}>
            <div className={styles.checkboxContainer}>
              <FormControlLabel
                  control={<Checkbox checked={isPermanent}
                                     onChange={event => setIsPermanent(event.target.checked)}/>}
                  label="Is Permanent (Has no end date)"
                  labelPlacement="top"
              />
            </div>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                  value={missionStartTime}
                  disabled={isPermanent}
                  onChange={setMissionStartTime}
                  label="Mission Start*"/>
              <DateTimePicker
                  value={missionEndTime}
                  disabled={isPermanent}
                  onChange={setMissionEndTime}
                  label="Mission End*"/>
            </LocalizationProvider>
          </div>
        </div>}

        {currentTab === TAB_TASKS && <TaskAdministrationList taskList={taskList} setTaskList={setTaskList}/>}
        {currentTab === TAB_PARTICIPANTS && <MissionParticipantsList mission={selectedMission}/>}
        {hasValue(hasAllMandatoryValues.tooltip) && <div className={styles.missingRaffleValuesContainer}>
          {'MISSING MANDATORY VALUES: ' + hasAllMandatoryValues.tooltip}
        </div>}
        <div className={styles.bottomActionContainer}>
          <Button
              className={styles.deleteButton}
              buttonType={BUTTON_TYPE_SECONDARY}
              disabled={!hasValue(id) || id === NEW_IDO_ID}
              text="DELETE"
              onClick={() => setOpenDeleteRaffleModal(true)}/>
          <div className={styles.flexGrower}/>
          <Button
              buttonType={BUTTON_TYPE_SECONDARY}
              text="Save Changes"
              onClick={saveChanges}
              disabled={hasAllMandatoryValues.disabled}/>
        </div>
      </div>}

      {openDeleteModal && <div className={styles.deleteIdoModalOverlay}>
        <div className={styles.deleteIdoModal}>
          <span>Are you sure you want to delete this Mission?</span>
          <div className={styles.deleteRow}>
            <Button buttonType={BUTTON_TYPE_SECONDARY} text="CANCEL"
                    onClick={() => setOpenDeleteModal(false)}/>
            <Button
                className={styles.deleteButton}
                buttonType={BUTTON_TYPE_SECONDARY}
                text="DELETE"
                onClick={deleteMission}/>
          </div>
        </div>
      </div>}
    </main>

  );
}

export default MissionCreateOrEdit;

